export const FIELD_CONDITION_OPERATORS = [
  { value: 'in', label: 'Is One Of' },
  { value: 'not_in', label: 'Is Not One Of' },
  { value: 'any', label: 'Has Any Value' },
];

export const FIELD_TYPES = [
  { value: 'text', label: 'Text', hasOptions: false },
  { value: 'number', label: 'Number', hasOptions: false },
  { value: 'select', label: 'Dropdown', hasOptions: true },
  { value: 'checkbox_group', label: 'Checkbox Group', hasOptions: true },
  { value: 'toggle', label: 'Toggle (Yes/No)', hasOptions: false },
  { value: 'date', label: 'Date', hasOptions: false },
  { value: 'textarea', label: 'Long Text', hasOptions: false },
];

export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'Equals', needsValue: true },
  { value: 'not_equals', label: 'Not Equals', needsValue: true },
  { value: 'not_empty', label: 'Is Not Empty', needsValue: false },
  { value: 'contains_any', label: 'Contains Any Of', needsValue: true, isArray: true },
  { value: 'in', label: 'Is One Of', needsValue: true, isArray: true },
];

export const SECTIONS = [
  'Specifications', 'Dimensions', 'Printing', 'Printing Details',
  'Finishing', 'Finishing & Post-Press', 'Other'
];

export const MACHINE_MAN_TYPES = [
  { value: '_none', label: 'Not Assigned' },
  { value: 'machine_man', label: 'Machine Operator' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'binder', label: 'Binder' },
];
